import * as Sentry from "@sentry/react";
import { NODE_ENV, REACT_APP_SENTRY_DSN } from "environmentVariables";
import { hasValue } from "Tools";

if (hasValue(REACT_APP_SENTRY_DSN)) {
  Sentry.init({
    environment: NODE_ENV,
    dsn: REACT_APP_SENTRY_DSN,
    tunnel: "/Home/SentryTunnel",
  });
}
